import { zip, CommentTypes } from "@repo/utils";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditorWebsocket } from "@hooks";
import { useEstimateEditorStore } from "@tools";

export const useCommentLinker = ( {
  version,
  path,
  viewedType,
  hasThread,
  onlyJumpToThread,
}) => {
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();
  const navigate = useNavigate();
  
  const [ linkCopied, setLinkCopied ] = useState(false);
  
  const getHref = () => {
    if(!hasThread)
      return "#";
    
    const d = { version, path, internal: Boolean(viewedType === CommentTypes.INTERNAL) };
    return `#${zip(JSON.stringify(d))}`;
  }
  
  const handleSetAnchor = (threadVisible) => {
    navigate(threadVisible && hasThread ? getHref() : "#");
  }
  
  const handleCopyLink = async (e) => {
    e.stopPropagation();
    if(!hasThread)
      return;
    const url = window.location.href
    await navigator.clipboard.writeText(`${url.replace(/#.*/, "")}${getHref()}`)
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 1000);
  }
  
  const handleJumpToComment = async (e, allowPropagation) => {
    if(!allowPropagation)
      e.stopPropagation();
    if(!hasThread)
      return;
    navigate(getHref());
    if(version !== editorStore.currentVersion) {
      if(socket?.editionPrivileges) {
        socket.requestExistingVersion(version);
        return;
      }
      // setSavingState(true);
      await editorStore.setCurrentVersion(version);
    }
    editorStore.setDisplayedComment({ version, path, internal: Boolean(viewedType === CommentTypes.INTERNAL), onlyJumpToThread });
  }
  
  return {
    linkCopied,
    handleSetAnchor,
    handleCopyLink,
    handleJumpToComment,
  }
}